import { Box, Card, TextField, Typography } from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import {
  NumberInput,
  BooleanInput,
  RadioButtonGroupInput,
  ValidationErrorMessage,
} from "react-admin";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";
import {
  setDiscount,
  setTresholdDiscount,
} from "../../../redux/actions/propertyActions";
import { Prize } from "../../../types/prize";
import { TicketRatesDiscount, TicketDiscount } from "../../../types/property";
import "./index.css";
import { comeBackIsCash } from "../../../helpers/checkDiscount";
import { FixedOdds } from "../../../types/fixedOdds";
import { Raffle } from "../../../types/raffle";
import {
  CreditProps,
  CreditsPickerComponent,
} from "../generalPickersBlocks/credits/CreditsPickerComponent";
import FreeTickets from "../freeTickets";
import { ExtraTickets } from "../../../types/generalSettings";
import { TicketsBoundles } from "../ticketsBoundles";

interface Props {
  isShow: boolean;
  isCash: boolean | undefined;
  isPercent: boolean | undefined;
  handleChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  removePercent?: () => void;
  removeCash?: () => void;
  entity: Raffle | Prize | FixedOdds | undefined;
  ticketPrice: number;
  discountSource: string;
  discountFillError: boolean;
  isOdds: boolean;
  isValidate: boolean;
  record?: Raffle;
  handleChangeCreditsStatus: () => void;
  handleChangeCreditsDateType: (e: any) => void;
  handleSetCredits: (arrr: Array<CreditProps>) => void;
  isActiveCredits: boolean;
  credits: Array<CreditProps>;
  handleSetDateValue: (val: string, dateName: string) => void;
  creditsStartDateValue: Date | string;
  creditsEndDateValue: Date | string;
  creditDateType: string;
  competition: string;
  freeTicketsRates?: Array<ExtraTickets>;
  isFreeTicketsActive?: boolean;
  isTicketsBoundsActive?: boolean;
  ticketsBounds?: Array<number>;
}

const roundedPrice = (price: number): number => {
  return Math.round((price + Number.EPSILON) * 100) / 100;
};

const calculateTrashold = (
  event: string,
  ticketPrice: number,
  data: Array<TicketRatesDiscount>
): Array<TicketRatesDiscount> => {
  let discounts = Array<TicketRatesDiscount>();
  if (event === "£") {
    discounts = data.map((item) => {
      const discountString = roundedPrice(
        100 - (item.percent * 100) / ticketPrice
      );
      item.newPrice = discountString;
      return item;
    });
  }
  if (event === "%") {
    discounts = data.map((item) => {
      const discountString = roundedPrice(
        ticketPrice - (ticketPrice / 100) * item.percent
      );
      item.newPrice = discountString;
      return item;
    });
  }
  return discounts;
};

const DiscountAndTickets: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    isPercent: true,
    isCash: false,
    label: "%",
    discount: 0,
    ticketPrice: 0,
    count: 0,
    ticketsTrasholdDiscount: Array<TicketRatesDiscount>(),
    ticketsDiscount: { percent: 0, newPrice: 2 },
    isActiveDiscount: false,
    isTrashholdActive: false,
  });
  const [requiredError, setRequiredError] = useState(false);
  const [maxTickets, setMaxTickets] = useState(0);
  const checkError = (index: number) => {
    const obj = state.ticketsTrasholdDiscount[index];
    if (obj.percent < 0.0) {
      return "Should be more then 0";
    }

    if (state.isPercent) {
      if (obj.percent > 99) {
        return "Should be less then 99";
      }
    }
    if (state.isCash) {
      if (obj.newPrice < 0)
        return `Should be less then ${
          state.isActiveDiscount
            ? state.ticketsDiscount.newPrice
            : state.ticketPrice
        }`;
    }
  };

  useEffect(() => {
    if (props.entity) {
      if (
        Object.keys(props.entity).length !== 0 &&
        typeof props.entity !== "string"
      ) {
        const percent =
          props.entity.discountCategory === "percent" ? true : false;
        const cash = props.entity.discountCategory === "cash" ? true : false;
        let label = props.entity.discountCategory === "percent" ? "%" : "£";
        let discountRates = props.entity.discountRates || [];
        let discountTicket =
          props.entity.discountTicket || state.ticketsDiscount;
        const isDiscountRates = props.record
          ? props.record.isDiscountRates
          : false;
        const isActiveDiscount = props.record
          ? props.record.isActiveDiscount
          : false;
        if (props.entity.discountRates && cash) {
          discountRates = comeBackIsCash(props.entity.discountRates);
        }
        if (props.isOdds) {
          setMaxTickets(props.entity.maxTickets);
        }
        setState({
          ...state,
          ticketPrice: props.entity.ticketPrice || props.ticketPrice,
          isPercent: percent,
          isCash: cash,
          label: label,
          ticketsTrasholdDiscount: discountRates,
          isTrashholdActive: props.entity.isDiscountRates || isDiscountRates,
          isActiveDiscount: props.entity.isActiveDiscount || isActiveDiscount,
          ticketsDiscount: discountTicket,
        });
        if (props.entity.discountTicket) {
          dispatch(setDiscount(props.entity.discountTicket));
        }
        dispatch(setTresholdDiscount(discountRates));
      }
      if (Object.keys(props.entity).length === 0) {
        setState({ ...state, isPercent: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateNumberInput = (
    value: string
  ): ValidationErrorMessage | undefined => {
    const errors: ValidationErrorMessage = {
      message: "",
      args: { message: "" },
    };
    if (!value) {
      setRequiredError(true);
      return (errors.message = "Required");
    }

    if (parseFloat(value) < 0) {
      setRequiredError(true);
      return (errors.message = "Should be more than 0");
    }

    return undefined;
  };

  const validateDefaultNumberInput = (
    value: string
  ): ValidationErrorMessage | undefined => {
    const errors: ValidationErrorMessage = {
      message: "",
      args: { message: "" },
    };
    if (!value) {
      setRequiredError(true);
      return (errors.message = "Required");
    }
    if (parseFloat(value) < 0) {
      setRequiredError(true);
      return (errors.message = "Should be more than 0");
    }

    if (props.isOdds) {
      if (parseFloat(value) > maxTickets) {
        return (errors.message = `Should be less than max tickets`);
      }
    }

    return undefined;
  };

  const handleOddsMaxTickets = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMaxTickets(parseInt(e.currentTarget.value));
  };

  const validateMaxTickets = (
    value: string
  ): ValidationErrorMessage | undefined => {
    const errors: ValidationErrorMessage = {
      message: "",
      args: { message: "" },
    };

    if (props.isOdds) {
      if (!value) {
        setRequiredError(true);
        return (errors.message = "Required");
      }

      if (parseFloat(value) < 0) {
        setRequiredError(true);
        return (errors.message = "Should be more than 0");
      }
      if (props.entity) {
        if (parseFloat(value) < props.entity.ticketsBought) {
          return (errors.message = `Should be more than ${props.entity.ticketsBought}`);
        }
      }
    }

    return undefined;
  };

  const handleSwitchDiscount = (event: boolean) => {
    let trasholdDiscount = Array<TicketRatesDiscount>();
    const discount: TicketDiscount = {
      percent:
        state.ticketsDiscount.percent === 0 ? 1 : state.ticketsDiscount.percent,
      newPrice: roundedPrice(
        state.ticketPrice -
          (state.ticketPrice / 100) * state.ticketsDiscount.percent
      ),
    };
    if (event) {
      trasholdDiscount = calculateTrashold(
        state.label,
        discount.newPrice,
        state.ticketsTrasholdDiscount
      );
    } else {
      trasholdDiscount = calculateTrashold(
        state.label,
        state.ticketPrice,
        state.ticketsTrasholdDiscount
      );
    }
    dispatch(setTresholdDiscount(trasholdDiscount));
    dispatch(setDiscount(discount));
    setState({
      ...state,
      isActiveDiscount: event,
      ticketsDiscount: {
        percent: discount.percent,
        newPrice: discount.newPrice,
      },
      ticketsTrasholdDiscount: trasholdDiscount,
    });
  };

  const handleSwitchTrasholdDiscount = (event: boolean) => {
    if (state.ticketsTrasholdDiscount.length === 0) {
      addDiscount();
    }
    setState({ ...state, isTrashholdActive: event });
  };

  const removeItem = (index: number) => {
    const discounts = state.ticketsTrasholdDiscount;
    discounts.splice(index, 1);
    dispatch(setTresholdDiscount(discounts));
    setState({ ...state, ticketsTrasholdDiscount: discounts });
  };

  const showDiscount = (discount: number) => {
    if (
      !discount ||
      isNaN(discount) ||
      discount === Infinity ||
      discount === -Infinity
    ) {
      return 0;
    }
    return roundedPrice(discount);
  };

  const addDiscount = () => {
    const discounts = state.ticketsTrasholdDiscount;
    const currentTicketPrice = state.isActiveDiscount
      ? state.ticketsDiscount.newPrice
      : state.ticketPrice;
    const newDiscount: TicketRatesDiscount = {
      amountTickets: 1,
      percent: 1,
      newPrice: state.isCash
        ? roundedPrice(100 - (1 * 100) / currentTicketPrice)
        : roundedPrice(currentTicketPrice - (currentTicketPrice / 100) * 1),
    };
    discounts.push(newDiscount);
    setState({ ...state, ticketsTrasholdDiscount: discounts });
  };

  const handleTicketPrice = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (parseInt(event.currentTarget.value) < 0) {
      return;
    }
    let discounts = Array<TicketRatesDiscount>();
    let ticketPrice = parseFloat(event.currentTarget.value);
    const newTicketPrice = roundedPrice(
      ticketPrice - (ticketPrice / 100) * state.ticketsDiscount.percent
    );
    const DiscountTicketPrice = state.isActiveDiscount
      ? newTicketPrice
      : ticketPrice;
    if (state.isPercent) {
      discounts = state.ticketsTrasholdDiscount.map((item) => {
        const discountString =
          DiscountTicketPrice -
          roundedPrice(DiscountTicketPrice / 100) * item.percent;
        item.newPrice = discountString;
        return item;
      });
    }
    if (state.isCash) {
      discounts = state.ticketsTrasholdDiscount.map((item) => {
        const discountString =
          100 - roundedPrice((item.percent * 100) / DiscountTicketPrice);
        item.newPrice = discountString;
        return item;
      });
    }
    dispatch(setTresholdDiscount(discounts));
    dispatch(
      setDiscount({
        percent: state.ticketsDiscount.percent,
        newPrice: newTicketPrice,
      })
    );
    setState({
      ...state,
      ticketPrice: ticketPrice,
      ticketsTrasholdDiscount: discounts,
      ticketsDiscount: {
        percent: state.ticketsDiscount.percent,
        newPrice: newTicketPrice,
      },
    });
  };

  const handleRadio = (event: React.FormEvent<HTMLDivElement>) => {
    let discounts = Array<TicketRatesDiscount>();
    const ticketPrice = state.isActiveDiscount
      ? state.ticketsDiscount.newPrice
      : state.ticketPrice;
    if (event.toString() === "cash") {
      discounts = state.ticketsTrasholdDiscount.map((item) => {
        const discountString = (
          100 -
          (item.percent * 100) / ticketPrice
        ).toFixed(2);
        item.newPrice = parseFloat(discountString);
        return item;
      });
      dispatch(setTresholdDiscount(discounts));
      setState({
        ...state,
        isCash: true,
        isPercent: false,
        label: "£",
        ticketsTrasholdDiscount: discounts,
      });
    }
    if (event.toString() === "percent") {
      discounts = state.ticketsTrasholdDiscount.map((item) => {
        const discountString =
          ticketPrice - roundedPrice(ticketPrice / 100) * item.percent;
        item.newPrice = discountString;
        item.percent = parseInt(item.percent.toString());
        return item;
      });
      dispatch(setTresholdDiscount(discounts));
      setState({
        ...state,
        ticketsTrasholdDiscount: discounts,
        isCash: false,
        isPercent: true,
        label: "%",
      });
    }
  };

  const calculateTrasholdDiscount = (percent: number) => {
    let discount = 0;
    const ticketPrice = state.isActiveDiscount
      ? state.ticketsDiscount.newPrice
      : state.ticketPrice;
    if (state.isPercent) {
      discount = roundedPrice(ticketPrice - (ticketPrice / 100) * percent);
    }
    if (state.isCash) {
      discount = 100 - (percent * 100) / ticketPrice;
      discount = roundedPrice(discount);
    }
    return discount;
  };

  const handleNewTicketPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const arrNewTicketPrice = e.currentTarget.value.split(".");
    if (arrNewTicketPrice.length === 2) {
      if (arrNewTicketPrice[1].length > 2) {
        return;
      }
    }
    const newTicketPrice = parseFloat(e.currentTarget.value);
    if (newTicketPrice > state.ticketPrice - 0.01 || newTicketPrice < 0) {
      return;
    }
    const discount: TicketDiscount = {
      newPrice: roundedPrice(newTicketPrice),
      percent: parseInt(
        (100 - (newTicketPrice * 100) / state.ticketPrice).toFixed(2)
      ),
    };
    const trasholdDiscount = calculateTrashold(
      state.label,
      discount.newPrice,
      state.ticketsTrasholdDiscount
    );
    dispatch(setTresholdDiscount(trasholdDiscount));
    dispatch(setDiscount(discount));
    setState({
      ...state,
      ticketsDiscount: discount,
      ticketsTrasholdDiscount: trasholdDiscount,
    });
  };

  const handleDiscontPercent = (e: React.ChangeEvent<HTMLInputElement>) => {
    let trasholdDiscount = Array<TicketRatesDiscount>();
    const percent = parseFloat(e.currentTarget.value);
    if (percent > 99 || percent < 0) {
      return;
    }
    const discount: TicketDiscount = {
      percent: percent,
      newPrice: roundedPrice(
        state.ticketPrice - (state.ticketPrice / 100) * percent
      ),
    };
    trasholdDiscount = calculateTrashold(
      state.label,
      discount.newPrice,
      state.ticketsTrasholdDiscount
    );
    dispatch(setTresholdDiscount(trasholdDiscount));
    dispatch(setDiscount(discount));
    setState({
      ...state,
      ticketsDiscount: discount,
      ticketsTrasholdDiscount: trasholdDiscount,
    });
  };

  const checkCount = (index: number) => {
    if (index !== 0) {
      if (
        state.ticketsTrasholdDiscount[index - 1].amountTickets >=
        state.ticketsTrasholdDiscount[index].amountTickets
      ) {
        return true;
      }
    }
    return false;
  };

  const handleCount = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const discounts = state.ticketsTrasholdDiscount;
    discounts[index].amountTickets = parseInt(e.currentTarget.value);
    const discount = calculateTrasholdDiscount(discounts[index].percent);
    discounts[index].newPrice = discount;
    dispatch(setTresholdDiscount(discounts));
    setState({ ...state, ticketsTrasholdDiscount: discounts });
  };

  const handlePercent = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const discounts = state.ticketsTrasholdDiscount;
    discounts[index].percent = parseFloat(e.currentTarget.value);
    const discount = calculateTrasholdDiscount(discounts[index].percent);
    discounts[index].newPrice = discount;
    dispatch(setTresholdDiscount(discounts));
    setState({ ...state, ticketsTrasholdDiscount: discounts });
  };

  return (
    <Box display={{ md: "block", lg: "flex" }} justifyContent="space-between">
      <Box
        width={{ md: "100%", lg: "48%" }}
        display={{ md: "block", lg: "flex" }}
        flexDirection="column"
      >
        <Box marginTop="2em">
          <Card>
            <Box padding="2em">
              <Typography variant="h6" gutterBottom className="base-color">
                Tickets
              </Typography>
              <hr />
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Typography gutterBottom className="base-color">
                  Ticket price
                </Typography>
                <Box>
                  <NumberInput
                    onChange={handleTicketPrice}
                    className="input-form"
                    source="ticketPrice"
                    label="price"
                    min={0.01}
                    step={0.01}
                    disabled={props.isShow}
                  />
                  <Box marginTop="1em" marginLeft="1em">
                    {props.isValidate && (
                      <div className="common-error">Required</div>
                    )}
                  </Box>
                </Box>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Box paddingRight="1em">
                  <Typography gutterBottom className="base-color">
                    Default number of tickets
                  </Typography>
                </Box>
                <Box>
                  <NumberInput
                    className="input-form"
                    disabled={props.isShow}
                    source="defaultTickets"
                    min={1}
                    label="count"
                  />
                  <Box marginTop="1em" marginLeft="1em">
                    {props.isValidate && (
                      <div className="common-error">Required</div>
                    )}
                  </Box>
                </Box>
              </Box>

              {props.isOdds && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Box paddingRight="1em">
                    <Typography gutterBottom className="base-color">
                      Number of tickets
                    </Typography>
                  </Box>
                  <Box>
                    <NumberInput
                      className="input-form"
                      disabled={props.isShow}
                      source="maxTickets"
                      min={1}
                      label="count"
                      onChange={handleOddsMaxTickets}
                    />
                    <Box marginTop="1em" marginLeft="1em">
                      {props.isValidate && !requiredError && (
                        <div className="common-error">Required</div>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
              <Box display="flex" alignItems="center">
                <Box marginBottom="10px">
                  <Typography gutterBottom className="base-color">
                    Discount:
                  </Typography>
                </Box>

                <BooleanInput
                  label=""
                  source="isActiveDiscount"
                  disabled={props.isShow}
                  onChange={handleSwitchDiscount}
                />
              </Box>
              {state.isActiveDiscount && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  className="base-color"
                  fontFamily="SF UI Display Light"
                >
                  <span className="discount-is">discount is</span>
                  <Box maxWidth="6em">
                    <TextField
                      type="number"
                      label="%"
                      className="discount-field"
                      value={state.ticketsDiscount.percent || ""}
                      onChange={handleDiscontPercent}
                      defaultValue={1}
                      required
                    />
                    <Box marginTop="1em">
                      {!state.ticketsDiscount.percent &&
                        state.ticketsDiscount.percent !== 0 && (
                          <div className="date-error">Required</div>
                        )}
                    </Box>
                  </Box>
                  <span className="discount-is">new price is</span>
                  <Box maxWidth="6em">
                    <TextField
                      type="number"
                      label="£"
                      className="discount-field"
                      value={state.ticketsDiscount.newPrice}
                      inputProps={{ step: 0.01 }}
                      onChange={handleNewTicketPrice}
                      defaultValue={1}
                      required
                    />
                    <Box marginTop="1em">
                      {!state.ticketsDiscount.newPrice && (
                        <div className="date-error">Required</div>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Card>
        </Box>

        <Box marginTop="2em">
          <Card>
            <Box padding="2em">
              <Typography variant="h6" gutterBottom className="base-color">
                Discount
              </Typography>
              <hr />
              <Box
                display="flex"
                alignItems="center"
                marginBottom="-2em"
                justifyContent="flex-start"
              >
                <Box marginBottom="10px">
                  <Typography gutterBottom className="base-color">
                    Status:
                  </Typography>
                </Box>

                <BooleanInput
                  label=""
                  source="isDiscountRates"
                  disabled={props.isShow}
                  onChange={handleSwitchTrasholdDiscount}
                />

                <Box marginLeft="-7em">
                  <RadioButtonGroupInput
                    onChange={handleRadio}
                    defaultValue={"percent"}
                    source={props.discountSource}
                    label=""
                    choices={[
                      { id: "percent", name: "%" },
                      { id: "cash", name: "£" },
                    ]}
                  />
                </Box>
              </Box>
              {props.discountFillError &&
                state.ticketsTrasholdDiscount.length === 0 && (
                  <div className="common-error">
                    At least one discount value must be filled
                  </div>
                )}
              {state.isTrashholdActive && (
                <>
                  {state.ticketsTrasholdDiscount.map((item, i) => {
                    return (
                      <>
                        <Box
                          display="block"
                          className="base-color"
                          fontFamily="SF UI Display Light"
                          key={i}
                        >
                          <Box display="flex" alignItems="center">
                            <Box marginBottom="0.6em">
                              <TextField
                                type="number"
                                label="threshold"
                                className="discount-field"
                                value={item.amountTickets}
                                onChange={(e) => handleCount(e, i)}
                                defaultValue={1}
                                required
                              />
                              {state.ticketsTrasholdDiscount[i].amountTickets <
                                0 && (
                                <div className="discount-error">
                                  Should be more then 0
                                </div>
                              )}
                              {isNaN(
                                state.ticketsTrasholdDiscount[i].amountTickets
                              ) && (
                                <div className="discount-error">required</div>
                              )}
                              {checkCount(i) && (
                                <div className="discount-error">
                                  Should be more than previous value
                                </div>
                              )}
                            </Box>
                            <Box padding="1em" whiteSpace="nowrap">
                              ticket{" "}
                              {state.isPercent ? (
                                <span className="discount-is">discount is</span>
                              ) : (
                                <span className="discount-is">
                                  new price is
                                </span>
                              )}
                            </Box>
                            <Box>
                              {state.isPercent ? (
                                <TextField
                                  type="number"
                                  label="%"
                                  className="discount-field"
                                  value={item.percent}
                                  inputProps={{ step: 1 }}
                                  onChange={(e) => handlePercent(e, i)}
                                  required
                                />
                              ) : (
                                <TextField
                                  type="number"
                                  label="£"
                                  className="discount-field"
                                  value={item.percent}
                                  inputProps={{ step: 0.01 }}
                                  onChange={(e) => handlePercent(e, i)}
                                  required
                                />
                              )}
                              {isNaN(
                                state.ticketsTrasholdDiscount[i].percent
                              ) && (
                                <div className="discount-error">required</div>
                              )}
                              {
                                <div className="discount-error">
                                  {checkError(i)}
                                </div>
                              }
                            </Box>
                            <Box padding="2em" whiteSpace="nowrap">
                              {state.isPercent ? (
                                <span className="discount-is">
                                  new price is
                                </span>
                              ) : (
                                <span className="discount-is">discount is</span>
                              )}
                              {showDiscount(item.newPrice).toFixed(2)}{" "}
                              {state.isPercent ? "£" : "%"}
                            </Box>
                            <CloseIcon
                              className="remove-discount"
                              onClick={() => removeItem(i)}
                            />
                          </Box>
                        </Box>
                      </>
                    );
                  })}
                  <AddCircleIcon
                    onClick={addDiscount}
                    className="add-discount"
                  />
                </>
              )}
            </Box>
          </Card>
        </Box>
      </Box>
      <Box marginTop="2em" width={{ md: "100%", lg: "48%" }}>
        <Card>
          <Box padding="2em">
            <Typography variant="h6" gutterBottom className="base-color">
              Credits
            </Typography>
            <hr />
            <Box>
              <CreditsPickerComponent
                handleChangeCreditsStatus={props.handleChangeCreditsStatus}
                handleSetCredits={props.handleSetCredits}
                isActiveCredits={props.isActiveCredits}
                credits={props.credits}
                withDateSelection={true}
                handleSaveCredits={() => {}}
                withSaveBtn={false}
                handleSetDateValue={props.handleSetDateValue}
                startDate={props.creditsStartDateValue}
                endDate={props.creditsEndDateValue}
                dateType={props.creditDateType}
                handleSetDateType={props.handleChangeCreditsDateType}
              />
            </Box>
          </Box>
        </Card>

        {props.competition === "raffle" && (
          <Box marginTop="2em">
            <Card>
              <Box padding="2em">
                <Typography variant="h6" gutterBottom className="base-color">
                  Free Tickets
                </Typography>
                <hr />
                <Box>
                  <FreeTickets
                    price={state.ticketPrice}
                    freeTickets={props.freeTicketsRates}
                    isFreeTicketsActive={props.isFreeTicketsActive}
                  />
                </Box>
              </Box>
            </Card>
          </Box>
        )}
        {props.competition === "raffle" && (
          <Box marginTop="2em">
            <Card>
              <Box padding="2em">
                <Typography variant="h6" gutterBottom className="base-color">
                  Tickets Bundles
                </Typography>
                <hr />
                <Box>
                  <TicketsBoundles ticketsBundles={props.ticketsBounds || []} />
                </Box>
              </Box>
            </Card>
          </Box>
        )}
      </Box>
    </Box>
  );
};

interface CustomProps {
  discount: number;
  cash: boolean;
}

export default DiscountAndTickets;
